webpackJsonp([35783957827783],{

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 30px;\n  margin-top: 50px;\n  padding: 0px 80px;\n  @media screen and (max-width: 1000px) {\n    padding: 0px 10px;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 30px;\n  margin-top: 50px;\n  padding: 0px 80px;\n  @media screen and (max-width: 1000px) {\n    padding: 0px 10px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 30px;\n  margin-bottom: 30px;\n  font-size: 32px;\n  color: #333333;\n  line-height: 1.6;\n  a {\n    color: #333333;\n    text-decoration: none;\n    font-style: none;\n    border-bottom: 2px solid #739381;\n    &:hover {\n      border-bottom: 3px solid #e26741;\n    }\n  }\n  @media screen and (max-width: 1000px) {\n    font-size: 18px;\n  }\n'], ['\n  margin-top: 30px;\n  margin-bottom: 30px;\n  font-size: 32px;\n  color: #333333;\n  line-height: 1.6;\n  a {\n    color: #333333;\n    text-decoration: none;\n    font-style: none;\n    border-bottom: 2px solid #739381;\n    &:hover {\n      border-bottom: 3px solid #e26741;\n    }\n  }\n  @media screen and (max-width: 1000px) {\n    font-size: 18px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(54);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(23);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactEntypoIcons = __webpack_require__(191);
	
	var _separator = __webpack_require__(24);
	
	var _separator2 = _interopRequireDefault(_separator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var IconWrapper = _styledComponents2.default.div(_templateObject);
	
	var InfoText = _styledComponents2.default.p(_templateObject2);
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      InfoText,
	      null,
	      'Learn more ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/about' },
	        'about me.'
	      )
	    ),
	    _react2.default.createElement(
	      InfoText,
	      null,
	      'Look at ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/projects' },
	        'projects I\'ve worked on.'
	      )
	    ),
	    _react2.default.createElement(
	      InfoText,
	      null,
	      'Read ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/blog' },
	        'things I\'ve written.'
	      )
	    ),
	    _react2.default.createElement(_separator2.default, null),
	    _react2.default.createElement(
	      InfoText,
	      null,
	      'Send me an email, or find me on GitHub and LinkedIn:'
	    ),
	    _react2.default.createElement(
	      IconWrapper,
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:rers97@gmail.com' },
	        _react2.default.createElement(_reactEntypoIcons.EntypoMailWithCircle, {
	          style: {
	            fill: '#497FA4',
	            width: '4em',
	            height: '4em'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/reroche/' },
	        _react2.default.createElement(_reactEntypoIcons.EntypoGithubWithCircle, {
	          style: {
	            fill: '#497FA4',
	            width: '4em',
	            height: '4em'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://linkedin.com/in/reroche/' },
	        _react2.default.createElement(_reactEntypoIcons.EntypoLinkedinWithCircle, {
	          style: {
	            fill: '#497FA4',
	            width: '4em',
	            height: '4em'
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(_separator2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-750ef9df829d89aafc57.js